import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { Provider } from "react-redux";
import store from "./store/store.js";
import "./index.css";
import "react-loading-skeleton/dist/skeleton.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://6e49b9d78c9eef43a07a452d6b721d24@o4506095969697792.ingest.sentry.io/4506095972450304",
  beforeSend(event) {
    let request = event.request;
  },
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", "womenwavemakers.com"],
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Custom event processor
function sanitizeEvent(event) {
  // Remove sensitive query parameters from the URL
  if (event.request && event.request.url) {
    const url = new URL(event.request.url);
    url.searchParams.delete("name");
    url.searchParams.delete("address1");
    url.searchParams.delete("address2");
    url.searchParams.delete("city");
    url.searchParams.delete("state");
    url.searchParams.delete("zip");
    url.searchParams.delete("phone");
    url.searchParams.delete("email");
    event.request.url = url.toString();
  }

  // Add additional scrubbing logic for other data as needed

  return event;
}

Sentry.addGlobalEventProcessor(sanitizeEvent);

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <App />
  </Provider>,
);
